import { render } from "./Poper.vue?vue&type=template&id=72c3f677&scoped=true&ts=true"
import script from "./Poper.vue?vue&type=script&lang=ts"
export * from "./Poper.vue?vue&type=script&lang=ts"

import "./Poper.vue?vue&type=style&index=0&id=72c3f677&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c3f677"]])

export default __exports__